// tslint:disable
export enum ExtauthValidationType {
    /**
     * @description UserName only
     */
    UserName = 0,
    /**
     * @description UserName and Password combo
     */
    Password = 1,
    /**
     * @description Security Question and Answer
     */
    KnowledgeBase = 2,
}
(ExtauthValidationType as any)['USERNAME'] = 0;
(ExtauthValidationType as any)['PASSWORD'] = 1;
(ExtauthValidationType as any)['KNOWLEDGEBASE'] = 2;
